// extracted by mini-css-extract-plugin
export default {"chainModal":"chainModal_TILdx","title":"title_FGlUd","chainItem":"chainItem_GLheS","active":"active_WOs46","back":"back_CzCwu"};